export default "__VITE_ASSET__TSimnCvt__"